import React from 'react';
import './App.css';
import 'primereact/resources/primereact.min.css'; // Estilos principais do PrimeReact
import 'primeicons/primeicons.css'; // Ícones do PrimeIcons
import "primeflex/primeflex.css";
import Layout from './layout/Layout';
import { ThemeProvider } from './ThemeContext';
import { Route, Routes, BrowserRouter as Router } from 'react-router-dom';
import { isAuthenticated } from './providers/isAutenticate';
import Login from './layout/Login/Login';
import { Navigate } from 'react-router-dom';  // Usando Navigate em vez de Redirect
import LayoutNovo from './layout/LayoutNovo';
import { useLocalStorage } from 'primereact/hooks';
import Empresas from './layout/Views/Empresas/Empresas';
import Usuarios from './layout/Views/Usuarios/Usuarios';
import Clientes from './layout/Views/Clientes/Clientes';
import ImportClientesCSV from './layout/Views/Clientes/ImportClientesCSV'
import LayoutV2 from './LayoutV2/LayoutV2';
import VisaoParque from './layout/Views/Coletas/VisaoParque';
import VisaoDescobertas from './layout/Views/Coletas/VisaoDescobertas';
import VisaoPrevisoesToner from './layout/Views/Coletas/VisaoPrevisoesToner';
import VisaoParqueDesconectados from './layout/Views/Coletas/VisaoParqueDesconectados';
import VisaoParqueDesabilitados from './layout/Views/Coletas/VisaoParqueDesabilitados';
import VisaoAlertasSuprimentos from './layout/Views/Coletas/VisaoAlertasSuprimentos';
import VisaoTrocasSuprimentos from './layout/Views/Coletas/VisaoTrocasSuprimentos';
import VisaoTrocaParts from './layout/Views/Coletas/VisaoTrocaParts';
import VisaoAlertasManutencao from './layout/Views/Coletas/VisaoAlertasManutencao';
import VisaoAtolamentos from './layout/Views/Coletas/VisaoAtolamentos';
import VisaoParqueInventory from './layout/Views/Coletas/Inventory/VisaoParqueInventory';
import DashboardRevenda from './layout/Views/Dashboard/DashboardRevenda'
import ClientesRelatorios from './layout/Views/Clientes/ClientesRelatorios';
import Revendas from './layout/Views/Revendas/Revendas'
import VisaoParqueInventoryMaps from './layout/Views/Coletas/Inventory/VisaoParqueInventoryMaps';
import LicencasCollector from './layout/Views/LicencasCollector/LicencasCollector';
import CadastroDCAs from './layout/Views/LicencasCollector/CadastroDCAs';
// Componente de Rota Privada
const PrivateRoute = ({ children }) => {
  return isAuthenticated() ? children : <Navigate to="/" />;
};

function App() {
  const [theme, setTheme] = useLocalStorage('mira', 'selectedTheme');
  
  React.useEffect(() => {
      const link = document.getElementById('theme-link');
      if (link) {
        
        link.href = `/styles/${theme}.css`;
      }
  }, [theme]);


  return (
    <ThemeProvider> {/* Mover o ThemeProvider para fora do Routes */}
      <Router>
        <Routes>
          {/* Definir as rotas */}
          <Route path="/" element={<Login />} />
          <Route path="/teste" element={<LayoutV2 />} />
          <Route path="/importar-clientes" element={<ImportClientesCSV />} />
          <Route 
            path="/home" 
            element={
              <PrivateRoute>
                <Layout />
              </PrivateRoute>
            } 
          /> 
           <Route 
            path="/home2" 
            element={
              <PrivateRoute>
                <LayoutNovo />
              </PrivateRoute>
            } 
          /> 
          <Route 
            path="/empresas" 
            element={
              <PrivateRoute>
                <Empresas />
              </PrivateRoute>
            } 
          /> 
          <Route 
            path="/usuarios-revenda" 
            element={
              <PrivateRoute>
                <Usuarios />
              </PrivateRoute>
            } 
          /> 

          <Route 
            path="/clientes" 
            element={
              <PrivateRoute>
                <Clientes />
              </PrivateRoute>
            } 
          /> 

          <Route 
            path="/revendas" 
            element={
              <PrivateRoute>
                <Revendas />
              </PrivateRoute>
            } 
          /> 

          <Route 
            path="/parque-equipamentos" 
            element={
              <PrivateRoute>
                <VisaoParque />
              </PrivateRoute>
            } 
          /> 
          <Route 
            path="/descobertas-equipamentos" 
            element={
              <PrivateRoute>
                <VisaoDescobertas />
              </PrivateRoute>
            } 
          /> 
          <Route 
            path="/previsoes-troca" 
            element={
              <PrivateRoute>
                <VisaoPrevisoesToner />
              </PrivateRoute>
            } 
          /> 
          <Route 
            path="/parque-desconectados" 
            element={
              <PrivateRoute>
                <VisaoParqueDesconectados />
              </PrivateRoute>
            } 
          /> 
        <Route 
            path="/parque-desabilitados" 
            element={
              <PrivateRoute>
                <VisaoParqueDesabilitados />
              </PrivateRoute>
            } 
          /> 

        <Route 
            path="/alertas-suprimentos" 
            element={
              <PrivateRoute>
                <VisaoAlertasSuprimentos />
              </PrivateRoute>
            } 
          /> 

        <Route 
            path="/trocas-toner" 
            element={
              <PrivateRoute>
                <VisaoTrocasSuprimentos />
              </PrivateRoute>
            } 
          /> 

          <Route 
            path="/alertas-pecas" 
            element={
              <PrivateRoute>
                <VisaoTrocaParts />
              </PrivateRoute>
            } 
          /> 

          <Route 
            path="/alertas-manutencao" 
            element={
              <PrivateRoute>
                <VisaoAlertasManutencao />
              </PrivateRoute>
            } 
          /> 

          <Route 
            path="/alertas-atolamento" 
            element={
              <PrivateRoute>
                <VisaoAtolamentos />
              </PrivateRoute>
            } 
          />
          <Route 
            path="/parque-inventory" 
            element={
              <PrivateRoute>
                <VisaoParqueInventory />
              </PrivateRoute>
            } 
          />  

          <Route 
            path="/licencas-collector" 
            element={
              <PrivateRoute>
                <LicencasCollector />
              </PrivateRoute>
            } 
          />  


        <Route 
            path="/cadastro-dcas" 
            element={
              <PrivateRoute>
                <CadastroDCAs />
              </PrivateRoute>
            } 
          />  

          

          <Route 
            path="/parque-inventory-maps" 
            element={
              <PrivateRoute>
                <VisaoParqueInventoryMaps />
              </PrivateRoute>
            } 
          />    

          
          <Route 
            path="/painel-revenda" 
            element={
              <PrivateRoute>
                <DashboardRevenda />
              </PrivateRoute>
            } 
          />  

          <Route 
            path="/painel-relatorios-clientes" 
            element={
              <PrivateRoute>
                <ClientesRelatorios />
              </PrivateRoute>
            } 
          />  



        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
